<div style="background-color: rgba(0, 0, 0, 0.63); height: 100vh;">
    <video autoplay style="height: 100%; width: 100%;" src={{resourceURL}} controls></video>
</div>
